<template>
  <v-autocomplete
    color="primary"
    v-model="stockPositionSelected"
    :clearable="!unclearable"
    :items="stockPositionItems"
    :loading="stockPositionLoading"
    :search-input.sync="stockPositionSearch"
    item-value="id"
    item-text="Description"
    item-disabled="disabled"
    :label="noLabel ? '' : label ? label : $t('Position.ObjectName')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    chips
    multiple
    deletable-chips
    small-chips
    :disabled="disabled"
  >
  </v-autocomplete>
</template>

<script>
import i18n from "@/i18n";
import StockPosition from "@/api/stock_position";
import Stocks from "@/api/stocks";

export default {
  name: "SearcherStockPositions",

  props: {
    value: Array,
    stockId: Number,
    dense: Boolean,
    status: Number,
    noLabel: Boolean,
    label: String,
    unclearable: Boolean,
    disabledItems: Array,
    disabled: Boolean,
  },

  computed: {
    stockPositionItems() {
      return this.stockPosition.map((position) => {
        var Description = i18n.t("MovePositionOrder.DetailFields.position", [
          position.position_code,
          position.position_name,
        ]);
        if (this.stock && this.stock.position_name_display) {
          if (this.stock.position_name_display.indexOf(2) > -1) {
            Description = position.position_name;
          }
          if (
            this.stock.position_name_display.indexOf(4) > -1 &&
            position.stock_roadway
          ) {
            Description = position.stock_roadway.code + " - " + Description;
          }
          if (
            this.stock.position_name_display.indexOf(3) > -1 &&
            position.stock_area
          ) {
            Description = position.stock_area.area_name + " - " + Description;
          }
        }
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.position_id == position.id
            )
          : false;
        return Object.assign({}, position, { Description, disabled });
      });
    },
  },

  data: () => ({
    stock: [],
    stockPosition: [],
    stockPositionLoading: false,
    stockPositionSearch: "",
    stockPositionSelected: [],
  }),

  methods: {
    getStockPositionsFromAPI() {
      //获取仓库信息
      Stocks.fetchOne(this.stockId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock = response.data.stock;
          }
        }.bind(this)
      );
      //获取库位信息
      this.stockPositionLoading = true;
      StockPosition.fetchAllForSelect({
        stock_id: this.stockId,
        status: this.status,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stockPosition = response.data.stock_positions;
            }
            this.stockPositionLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.stockPositionLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.stockPositionSelected = this.value;
      },
    },
    stockPositionSelected: {
      handler() {
        this.$emit("input", this.stockPositionSelected);
      },
    },
    stockId: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.stockId) {
          this.getStockPositionsFromAPI();
        }        
      },
    },
  },
};
</script>